import { Box } from '@chaine/keychaine';
import React, { useEffect, useRef, useState } from 'react';
import Conversation from './conversation';
export var Direction;
(function (Direction) {
    Direction["Inbound"] = "inbound";
    Direction["Outbound"] = "outbound";
})(Direction || (Direction = {}));
export function AnimatedConversation(params) {
    const { messages } = params;
    const [currentValue, setCurrentValue] = useState(-1);
    const ref = useRef(null);
    const [displayIndicator, setDisplayIndicator] = useState(false);
    const run = (current = 0) => {
        const item = messages[current];
        const next = current + 1;
        if (current < messages.length) {
            if (messages[current])
                setTimeout(() => {
                    if (messages[current].direction === 'outbound') {
                        setTimeout(() => {
                            if (messages[current].systemMessage)
                                setDisplayIndicator(false);
                            else if (messages[next].systemMessage)
                                setDisplayIndicator(false);
                            else if (next === messages.length)
                                setDisplayIndicator(false);
                            else
                                setDisplayIndicator(true);
                        }, 1000);
                    }
                    else
                        setDisplayIndicator(false);
                    setCurrentValue(next);
                    run(next);
                }, item.delay);
        }
        else
            setTimeout(() => {
                run();
            }, 6000);
    };
    useEffect(run, []);
    return (React.createElement(Box, { ref: ref }, currentValue >= 0 && (React.createElement(Conversation, { messages: messages.slice(0, currentValue), displayIndicator: displayIndicator }))));
}
